import { PlayerRepository } from '../../../state/reduxRepositories';
import { Player } from '../../../state/reduxRepositories/players/player.interfaces';
import { createDeepEqualSelector } from '../../../state/selector.helpers';
import { AddConneqtView } from './addConneqt.view.service';
import {
  ConneqtStatus,
  ViewConneqtPayload,
} from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { SentConneqtDomain } from '../sent/sentConneqt.domain';
import { AllConneqtsDomain } from '../allConneqtRequests/allConneqts.domain';
import { dateTime } from '../../../time/datetime';

export class AddConneqtSelectors {
  protected selectedPlayerCluesSelector: (state: any) => string | undefined;
  protected conneqtWithEmailNotFoundSelector: any;
  protected pendingConneqtSelector: any;
  protected alreadyConneqtedSelector: any;

  constructor(
    protected playerRepository: PlayerRepository,
    protected addConneqtView: AddConneqtView,
    protected sentConneqtDomain: SentConneqtDomain,
    protected allConneqtsDomain: AllConneqtsDomain,
  ) {
    this.selectedPlayerCluesSelector = this.createSelectedPlayerCluesSelector();
    this.conneqtWithEmailNotFoundSelector =
      this.createConneqtWithEmailNotFoundSelector();
    this.pendingConneqtSelector = this.createPendingConneqtSelector();
    this.alreadyConneqtedSelector = this.createAlreadyConneqtedSelector();
  }

  private createSelectedPlayerCluesSelector = () => {
    return createDeepEqualSelector(
      this.playerRepository.selectors.resourcesSelector,
      this.addConneqtView.viewStateSelector,
      (players: Player[], viewState) => {
        if (!viewState.selectedPlayerId) return undefined;

        const player = players.find((_player) => {
          return _player.id === viewState.selectedPlayerId;
        });

        if (!player) return undefined;

        return `${player.firstName} ${
          player.lastName
        },${dateTime.formatToUtcIsoDate(player?.dateOfBirth)}`;
      },
    );
  };

  private createConneqtWithEmailNotFoundSelector = () => {
    return createDeepEqualSelector(
      this.sentConneqtDomain.sentConneqts,
      this.addConneqtView.viewStateSelector,
      (sentConneqts: ViewConneqtPayload[], viewState) => {
        return sentConneqts.find((conneqt) => {
          return (
            conneqt.responseEmail === viewState.responseEmail &&
            conneqt.status === ConneqtStatus.AccountNotFound
          );
        });
      },
    );
  };

  private createPendingConneqtSelector = () => {
    return createDeepEqualSelector(
      this.sentConneqtDomain.sentConneqts,
      this.addConneqtView.viewStateSelector,
      this.selectedPlayerCluesSelector,
      (sentConneqts: ViewConneqtPayload[], viewState, selectedPlayerClues) => {
        return sentConneqts.some((_conneqt) => {
          return (
            _conneqt.requestPlayerId === viewState.selectedPlayerId &&
            _conneqt.requestPlayerClues === selectedPlayerClues &&
            _conneqt.responseEmail === viewState.responseEmail &&
            _conneqt.status !== ConneqtStatus.REJECTED
          );
        });
      },
    );
  };

  private createAlreadyConneqtedSelector = () => {
    return createDeepEqualSelector(
      this.allConneqtsDomain.conneqts,
      this.addConneqtView.viewStateSelector,
      this.selectedPlayerCluesSelector,
      (conneqts: ViewConneqtPayload[], viewState, selectedPlayerClues) => {
        return conneqts.some((_conneqt) => {
          return (
            _conneqt.requestPlayerId === viewState.selectedPlayerId &&
            _conneqt.requestPlayerClues === selectedPlayerClues &&
            _conneqt.responseEmail === viewState.responseEmail
          );
        });
      },
    );
  };
}
